import classNames from "classnames";
import { Typography } from "components/atoms";
import { HeaderNotification } from "../HeaderNotification";
import "./index.scss";

interface IProps {
  isMobile?: boolean;
  isTab?: boolean;
  theme: "light" | "dark";
  styles?: string;
  leftContentStyle?: string;
  leftContentLabel: string;
  leftContentTypographyStyle?: string;
  isAlert?: boolean;
  customVariant?:
    | "h1Bold"
    | "h2Bold"
    | "h2Med"
    | "h3Bold"
    | "h3Med"
    | "h4Med"
    | "h4Bold"
    | "h5Bold"
    | "h6Bold"
    | "h6Medium"
    | "h6Underline"
    | "h6Book"
    | "h7Med"
    | "h7Bold"
    | "h7Book"
    | "h7Underline"
    | "h8Bold"
    | "h8Book"
    | "h8MedItalic"
    | "h8Italic"
    | "h8Med"
    | "h8Underline"
    | "h9Bold"
    | "h9Medium"
    | "h9Book";
}

export const Header = ({
  isTab=false,
  theme,
  styles,
  leftContentStyle,
  leftContentLabel,
  leftContentTypographyStyle,
  customVariant,
  isAlert,
}: IProps) => {
  return (
    <div className="header-wrapper">
      <div
        className={classNames("header-container", { [`${styles}`]: styles })}
      >
        <div
          className={classNames("left-content", {
            [`${leftContentStyle}`]: leftContentStyle,
          })}
        >
          <Typography
            variant={customVariant ? `${customVariant}` : "h1Bold"}
            label={leftContentLabel}
            styles={
              leftContentTypographyStyle && `${leftContentTypographyStyle}`
            }
          />
        </div>
        {!isTab ? <HeaderNotification theme={theme} isAlert={isAlert}/> : null}
      </div>
    </div>
  );
};


